<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
		<mask id="mask0_5391_45019" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="60"
			height="60">
			<path d="M0 0H60V60H0V0Z" fill="white" />
		</mask>
		<g mask="url(#mask0_5391_45019)">
			<path
				d="M45 33C45 34.6569 46.3431 36 48 36C49.6569 36 51 34.6569 51 33V30H54C55.6569 30 57 28.6569 57 27C57 25.3432 55.6569 24 54 24H51V21C51 19.3432 49.6569 18 48 18C46.3431 18 45 19.3432 45 21V24H42C40.3431 24 39 25.3431 39 27C39 28.6569 40.3431 30 42 30H45V33Z"
				fill="url(#paint0_linear_5391_45019)" />
			<path
				d="M37.0885 15.6575C37.0885 22.6481 31.4215 28.315 24.4309 28.315C17.4404 28.315 11.7734 22.6481 11.7734 15.6575C11.7734 8.66697 17.4404 3 24.4309 3C31.4215 3 37.0885 8.66697 37.0885 15.6575Z"
				fill="url(#paint1_linear_5391_45019)" />
			<path
				d="M2.00862 43.407C6.16401 40.1388 14.4338 34.8492 24.4308 34.8492C34.4277 34.8492 42.6978 40.1388 46.8531 43.407C48.708 44.8656 49.2864 47.3316 48.5541 49.5747L47.5545 52.6356C46.7046 55.2387 44.2767 57 41.5383 57H7.3233C4.5849 57 2.15713 55.2387 1.30713 52.6356L0.307671 49.5747C-0.424788 47.3316 0.153809 44.8656 2.00862 43.407Z"
				fill="url(#paint2_linear_5391_45019)" />
		</g>
		<defs>
			<linearGradient id="paint0_linear_5391_45019" x1="39" y1="31.5" x2="57" y2="31.5"
				gradientUnits="userSpaceOnUse">
				<stop stop-color="#F45484" />
				<stop offset="1" stop-color="#F51E78" />
			</linearGradient>
			<linearGradient id="paint1_linear_5391_45019" x1="11.7734" y1="21.9863" x2="11.7734" y2="21.9863"
				gradientUnits="userSpaceOnUse">
				<stop stop-color="#F45484" />
				<stop offset="1" stop-color="#F51E78" />
			</linearGradient>
			<linearGradient id="paint2_linear_5391_45019" x1="0" y1="51.4623" x2="0" y2="51.4623"
				gradientUnits="userSpaceOnUse">
				<stop stop-color="#F45484" />
				<stop offset="1" stop-color="#F51E78" />
			</linearGradient>
		</defs>
	</svg>
</template>